webpackJsonp([206145399751139],{

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/SLaMAfimage.2052466a.png";

/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/capCurve.e7342499.png";

/***/ }),

/***/ 845:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/plasticMechanism.7774abd4.png";

/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/updatePlots.d1244dbb.png";

/***/ }),

/***/ 1127:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background-image: url(', ');\n  background-size: 100%;\n  @media (min-width: 300px) {\n    background-position: center;\n    background-repeat: no-repeat;\n    height: 450px;\n  }\n'], ['\n  background-image: url(', ');\n  background-size: 100%;\n  @media (min-width: 300px) {\n    background-position: center;\n    background-repeat: no-repeat;\n    height: 450px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n\tposition: fixed;\n\tzIndex: 999;\n\tbackground-image: url(', ');\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n  @media (max-width: 299px) {\n    right: 10%;\n    bottom: 0%;\n    width: 20%;\n    height: 20%;\n  }\n  @media (min-width: 300px) {\n    right: 10%;\n    bottom: 0%;\n    width: 15%;\n    height: 15%;\n  }\n  @media (min-width: 600px) {\n    right: 7%;\n    bottom: 2%;\n    width: 12%;\n    height: 12%;\n  }\n  @media (min-width: 1100px) {\n    right: 2%;\n\t  bottom: 2%;\n\t  width: 15%;\n\t  height: 15%;\n\t}\n\n'], ['\n\tposition: fixed;\n\tzIndex: 999;\n\tbackground-image: url(', ');\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n  @media (max-width: 299px) {\n    right: 10%;\n    bottom: 0%;\n    width: 20%;\n    height: 20%;\n  }\n  @media (min-width: 300px) {\n    right: 10%;\n    bottom: 0%;\n    width: 15%;\n    height: 15%;\n  }\n  @media (min-width: 600px) {\n    right: 7%;\n    bottom: 2%;\n    width: 12%;\n    height: 12%;\n  }\n  @media (min-width: 1100px) {\n    right: 2%;\n\t  bottom: 2%;\n\t  width: 15%;\n\t  height: 15%;\n\t}\n\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeadlineWithFocus = __webpack_require__(6);
	
	var _HeadlineWithFocus2 = _interopRequireDefault(_HeadlineWithFocus);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _hedron = __webpack_require__(10);
	
	var _colorbar = __webpack_require__(12);
	
	var _colorbar2 = _interopRequireDefault(_colorbar);
	
	var _logo = __webpack_require__(845);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _SLaMAfimage = __webpack_require__(843);
	
	var _SLaMAfimage2 = _interopRequireDefault(_SLaMAfimage);
	
	var _updatePlots = __webpack_require__(847);
	
	var _updatePlots2 = _interopRequireDefault(_updatePlots);
	
	var _forcedrift = __webpack_require__(755);
	
	var _forcedrift2 = _interopRequireDefault(_forcedrift);
	
	var _hierarchy = __webpack_require__(756);
	
	var _hierarchy2 = _interopRequireDefault(_hierarchy);
	
	var _plasticMechanism = __webpack_require__(846);
	
	var _plasticMechanism2 = _interopRequireDefault(_plasticMechanism);
	
	var _capCurve = __webpack_require__(844);
	
	var _capCurve2 = _interopRequireDefault(_capCurve);
	
	var _license = __webpack_require__(757);
	
	var _license2 = _interopRequireDefault(_license);
	
	var _index = __webpack_require__(42);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _download = __webpack_require__(40);
	
	var _download2 = _interopRequireDefault(_download);
	
	var _reactScrollableAnchor = __webpack_require__(18);
	
	var _reactScrollableAnchor2 = _interopRequireDefault(_reactScrollableAnchor);
	
	var _reactResponsiveEmbed = __webpack_require__(26);
	
	var _reactResponsiveEmbed2 = _interopRequireDefault(_reactResponsiveEmbed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ImageWrapper = _styledComponents2.default.div.attrs({
	
			image: function image(props) {
					return props.image;
			}
	})(_templateObject, function (props) {
			return props.image;
	});
	
	var DownloadIconContainer = _styledComponents2.default.div(_templateObject2, _download2.default);
	
	var ImgColStyle = {
			padding: '0'
	};
	
	var RowStyleEVEN = {
			background: '#F9F9F9'
	};
	
	var RowStyleODD = {
			background: '#F5F5F5'
	};
	
	var About = function About(props) {
			return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
							'a',
							{ href: '#download' },
							_react2.default.createElement(DownloadIconContainer, null)
					),
					_react2.default.createElement(
							_hedron.Row,
							{ alignItems: 'center', style: RowStyleEVEN },
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
									_react2.default.createElement(ImageWrapper, { image: _logo2.default })
							),
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
									_react2.default.createElement(
											'h1',
											null,
											_react2.default.createElement(
													'u',
													{ style: { textDecoration: 'none', borderBottom: '10px solid #DFAB50' } },
													'SLaMA Solver Frame'
											)
									),
									_react2.default.createElement(
											'h3',
											null,
											_react2.default.createElement(
													'p',
													null,
													'The Simple Lateral Mechanism Analysis (SLaMA) allows to estimate both the plastic mechanism and the capacity curve (i.e. a force\u2013displacement curve) of reinforced concrete frames (among others). SLaMA Solver Frame provides a graphical user interface to apply SLaMA.'
											)
									)
							)
					),
					_react2.default.createElement(
							_hedron.Row,
							{ alignItems: 'center', style: RowStyleODD },
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
									_react2.default.createElement(ImageWrapper, { image: _SLaMAfimage2.default })
							),
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
									_react2.default.createElement(
											'h1',
											null,
											_react2.default.createElement(
													'u',
													{ style: { textDecoration: 'none', borderBottom: '12px solid #A661C2' } },
													'Completely standalone'
											),
											_react2.default.createElement('br', null)
									),
									_react2.default.createElement(
											'h3',
											null,
											_react2.default.createElement(
													'p',
													null,
													'You don\u2019t need any other software to run it'
											)
									)
							)
					),
					_react2.default.createElement(
							_hedron.Row,
							{ alignItems: 'center', style: RowStyleEVEN },
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
									_react2.default.createElement(ImageWrapper, { image: _updatePlots2.default })
							),
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
									_react2.default.createElement(
											'h1',
											null,
											_react2.default.createElement(
													'u',
													{ style: { textDecoration: 'none', borderBottom: '12px solid #DFAB50' } },
													'Type and Check Environment'
											)
									),
									_react2.default.createElement(
											'h3',
											null,
											_react2.default.createElement(
													'p',
													null,
													'Every time you input a parameter, a plot updates allowing for cross checks'
											)
									)
							)
					),
					_react2.default.createElement(
							_hedron.Row,
							{ alignItems: 'center', style: RowStyleODD },
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
									_react2.default.createElement(ImageWrapper, { image: _forcedrift2.default })
							),
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
									_react2.default.createElement(
											'h1',
											null,
											_react2.default.createElement(
													'u',
													{ style: { textDecoration: 'none', borderBottom: '12px solid #A661C2' } },
													'Member failure mode'
											)
									),
									_react2.default.createElement(
											'h3',
											null,
											_react2.default.createElement(
													'p',
													null,
													'For each beam and column, SLaMA solver Frame provides their expected failure mode: flexure, bar buckling, shear, lap splice'
											)
									)
							)
					),
					_react2.default.createElement(
							_hedron.Row,
							{ alignItems: 'center', style: RowStyleEVEN },
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
									_react2.default.createElement(ImageWrapper, { image: _hierarchy2.default })
							),
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
									_react2.default.createElement(
											'h1',
											null,
											_react2.default.createElement(
													'u',
													{ style: { textDecoration: 'none', borderBottom: '12px solid #DFAB50' } },
													'Hierarchy of strength'
											)
									),
									_react2.default.createElement(
											'h3',
											null,
											_react2.default.createElement(
													'p',
													null,
													'For each beam column joint sub-assembly, SLaMA Solver Frame determines its hierarchy of strength, indicating the member-level mechanism that causes its failure'
											)
									)
							)
					),
					_react2.default.createElement(
							_hedron.Row,
							{ alignItems: 'center', style: RowStyleODD },
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
									_react2.default.createElement(ImageWrapper, { image: _plasticMechanism2.default })
							),
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
									_react2.default.createElement(
											'h1',
											null,
											_react2.default.createElement(
													'u',
													{ style: { textDecoration: 'none', borderBottom: '12px solid #A661C2' } },
													'Plastic mechanism'
											)
									),
									_react2.default.createElement(
											'h3',
											null,
											_react2.default.createElement(
													'p',
													null,
													'By composing the results of each sub-assembly, SLaMA solver Frame provides an estimation of the plastic mechanism'
											)
									)
							)
					),
					_react2.default.createElement(
							_hedron.Row,
							{ alignItems: 'center', style: RowStyleEVEN },
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
									_react2.default.createElement(ImageWrapper, { image: _capCurve2.default })
							),
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
									_react2.default.createElement(
											'h1',
											null,
											_react2.default.createElement(
													'u',
													{ style: { textDecoration: 'none', borderBottom: '12px solid #DFAB50' } },
													'Global capacity curve'
											)
									),
									_react2.default.createElement(
											'h3',
											null,
											_react2.default.createElement(
													'p',
													null,
													'The results are composed to derive a force-displacement capacity curve (pushover) for three different plastic mechanisms: Beam Sway, Mixed Sway and Column Sway'
											)
									)
							)
					),
					_react2.default.createElement(
							_hedron.Row,
							{ alignItems: 'center', style: RowStyleODD },
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
									_react2.default.createElement(ImageWrapper, { image: _license2.default })
							),
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
									_react2.default.createElement(
											'h1',
											null,
											_react2.default.createElement(
													'u',
													{ style: { textDecoration: 'none', borderBottom: '12px solid #A661C2' } },
													'License'
											)
									),
									_react2.default.createElement(
											'h3',
											null,
											_react2.default.createElement(
													'p',
													null,
													'Creative commons \u201CAttribution-No Derivatives 4.0 International\u201D license'
											)
									)
							)
					),
					_react2.default.createElement(
							_hedron.Row,
							{ alignItems: 'center', style: RowStyleEVEN },
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
									_react2.default.createElement(_reactResponsiveEmbed2.default, { src: 'https://www.youtube.com/embed/_s6Hbr0A0ZA', allowFullScreen: true })
							),
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
									_react2.default.createElement(
											'h1',
											null,
											_react2.default.createElement(
													'u',
													{ style: { textDecoration: 'none', borderBottom: '12px solid #DFAB50' } },
													'In action'
											)
									),
									_react2.default.createElement(
											'h3',
											null,
											_react2.default.createElement(
													'p',
													null,
													'Watch this simple video tutorial'
											)
									)
							)
					),
					_react2.default.createElement(
							_hedron.Row,
							null,
							_react2.default.createElement(
									_reactScrollableAnchor2.default,
									{ id: 'download' },
									_react2.default.createElement(
											_hedron.Column,
											{ xs: 12, sm: 12, smShift: 0, md: 10, mdShift: 1, lg: 8, lgShift: 2 },
											_react2.default.createElement(_index2.default, { formName: 'SLaMAf' })
									)
							)
					)
			);
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-s-la-m-af-index-en-jsx-4899de2023db421c81fb.js